<template>
  <PetCreateForm :customer="customer" @create="onCreate" />
</template>

<script lang="ts" setup>

import {useRouter} from "vue-router";
import {usePatientStore} from "@/stores/patient.store";
import Customer from "@/customer/interfaces/Customer";
import {Pet} from "@/customer/interfaces/Pet";
import PetCreateForm from "@/customer/components/customer-beneficiary/PetCreateForm.vue";

defineProps<{
    customer: Customer;
}>();

const router = useRouter();
const {updatePet} = usePatientStore();

const onCreate = async (pet: Pet) => {
    await updatePet(pet);
    await router.push({name: 'customer.pet', params: {id: pet.id}});
};

</script>
